/**
 * @class
 */
import Base from 'netxcore@netx/core-search/collections/searchFacets';

export default class SearchFacets extends Base {
	/** @override */
	// portal wants them as they come
	comparator(a, b) {
		return 0;
	}
}
